// GENERATED AUTOMATICALLY
// DON NOT EDIT IT MANUALLY

import * as React from 'react';
import AntdIcon, { AntdIconProps } from '../components/AntdIcon';
import { IconDefinition } from '../types';

const ChevronDownOutlinedSvg: IconDefinition = {"icon":{"tag":"svg","attrs":{"viewBox":"0 0 512 512","focusable":"false"},"children":[{"tag":"path","attrs":{"d":"M233.4 406.6a32.05 32.05 0 0045.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z"}}]},"name":"chevron-down","theme":"outlined"};

const ChevronDownOutlined = (
  props: AntdIconProps,
  ref: React.MutableRefObject<HTMLSpanElement>,
) => <AntdIcon {...props} ref={ref} icon={ChevronDownOutlinedSvg} />;
  ChevronDownOutlined.displayName = 'ChevronDownOutlined';

export default React.forwardRef<HTMLSpanElement, AntdIconProps>(ChevronDownOutlined);
